import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../../util/Rest';
import {DISPOSITION_CODE} from '../../../constants/Lookup';
const initialData = {
  letterControlListData: {},
  listStatus: null,
  isLoading: false,
  errorMsg: null,
  dropDownData: {},
  successMsg: null,
  letterCodeData: {},
  deleteLetterStatus: null,
  viewFormFileUrl: null,
  letterListCodeData: {},
  letterPrintStatus: null,
  docKey: null,
  templateLink: null,
  letterNameData: [],
  listCodeData: {},
};

const slice = createSlice({
  name: 'postLetterControlList',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchLetterControlListData: (state, action) => {
      state.letterControlListData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchLetterCodeData: (state, action) => {
      state.letterCodeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchLetterNameData: (state, action) => {
      state.letterNameData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchListCodeData: (state, action) => {
      state.listCodeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchLetterListData: (state, action) => {
      state.letterListCodeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postLetterControlList: (state, action) => {
      state.listStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    postLetterListData: (state, action) => {
      state.letterPrintStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
      state.docKey = action.payload.message;
    },
    deleteLetterData: (state, action) => {
      state.deleteLetterStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    viewLetterData: (state, action) => {
      state.templateLink = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.message;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    resetStatus: (state, action) => {
      state.listStatus = null;
      state.isLoading = false;
      state.letterControlListData = {};
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload?.data?.message ? action.payload?.data?.message : action.payload;
      state.isLoading = false;
    },
    fetchSuccessGenerateUrl: (state, action) => {
      state.viewFormFileUrl = action.payload.data;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.deleteLetterStatus = null;
      state.letterPrintStatus = null;
    },
    resetUrl: (state, action) => {
      state.viewFormFileUrl = null;
      state.isLoading = false;
      state.errorMsg = null;
    },
  },
});

export default slice.reducer;

const {
  fetchStart,
  fetchLetterControlListData,
  fetchError,
  postLetterControlList,
  resetMsg,
  resetStatus,
  resetUrl,
  fetchDropDownData,
  fetchLetterCodeData,
  fetchSuccessGenerateUrl,
  fetchListCodeData,
  deleteLetterData,
  fetchLetterListData,
  fetchLetterNameData,
  postLetterListData,
  viewLetterData,
} = slice.actions;

export const postLetter = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lettermaintenance/save/lettercontrollist`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postLetterControlList(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postLetterList = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lettermaintenance/print/lettercontrollist`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postLetterListData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchLetterControlList = (letterControlListId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/find/lettercontrollist/${letterControlListId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchLetterControlListData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const getDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [DISPOSITION_CODE],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchLetterCode = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/find/all/lettercodeanddescription`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchLetterCodeData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchLetterNames = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/find/all/lettername`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchLetterNameData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchListCodes = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/find/all/listcodeanddesc`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchListCodeData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchLetterListCode = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/find/all/lettercontrollistcode`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchLetterListData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postGenerateUrl = (docKey) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/print/lettercontrollist/${docKey}`)
      .then((data) => {
        if (data?.status === 500 || data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchSuccessGenerateUrl(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const downloadFileByUrl = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lettermaintenance/generateurlprintlcl`, details)
      .then((data) => {
        if (data?.status === 500 || data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchSuccessGenerateUrl(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const ViewDocument = (docKey) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/view/${docKey}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(viewLetterData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const deleteLetter = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/delete/lettercontrollist/${id}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(deleteLetterData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const ResetStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};

export const ResetUrls = () => {
  return (dispatch) => {
    dispatch(resetUrl());
  };
};
